var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Contact_Normal"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Contact_Normal",
    clipPath: "url(#clip-Contact_Normal)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contacts",
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_38",
    "data-name": "Subtraction 38",
    d: "M-1079.29-573.358h-22.73a.981.981,0,0,1-.98-.98V-601.02a.981.981,0,0,1,.98-.98h22.73a.981.981,0,0,1,.979.98v26.682A.981.981,0,0,1-1079.29-573.358Zm-13.078-14.153a4.836,4.836,0,0,0-4.744,3.922.794.794,0,0,0-.033.285v2.346a1.578,1.578,0,0,0,1.576,1.576h9.922a1.578,1.578,0,0,0,1.576-1.576V-583.3a1.373,1.373,0,0,0-.028-.248l-.006-.037a4.839,4.839,0,0,0-4.743-3.922Zm1.743-8.465a3.86,3.86,0,0,0-3.856,3.856,3.86,3.86,0,0,0,3.856,3.855,3.859,3.859,0,0,0,3.855-3.855A3.86,3.86,0,0,0-1090.625-595.976Zm4.945,15.236h-9.906a.224.224,0,0,1-.218-.218v-2.38a3.5,3.5,0,0,1,3.419-2.833h3.5a3.47,3.47,0,0,1,3.42,2.833v2.38A.223.223,0,0,1-1085.68-580.739Zm-4.945-8.883a2.5,2.5,0,0,1-2.5-2.5,2.5,2.5,0,0,1,2.5-2.5,2.5,2.5,0,0,1,2.5,2.5A2.5,2.5,0,0,1-1090.625-589.622Z",
    transform: "translate(1105.464 602.687)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4637",
    "data-name": "Path 4637",
    d: "M31.961,37.24H11.97a3.022,3.022,0,0,1-3.02-3.015V10.255A3.022,3.022,0,0,1,11.97,7.24H31.961a3.022,3.022,0,0,1,3.02,3.015v8.567a.686.686,0,0,1-1.373,0V10.255a1.628,1.628,0,0,0-1.63-1.628H11.987a1.643,1.643,0,0,0-1.647,1.628V34.225a1.632,1.632,0,0,0,1.647,1.628H31.978a1.628,1.628,0,0,0,1.63-1.628V24.082a.686.686,0,0,1,1.373,0V34.225A3.022,3.022,0,0,1,31.961,37.24Z",
    transform: "translate(-7.157 -7.24)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2108",
    "data-name": "Group 2108",
    transform: "translate(0 4.852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4642",
    "data-name": "Path 4642",
    d: "M11.97,11.281H8.55a.67.67,0,1,1,0-1.341H11.97a.67.67,0,0,1,0,1.341Z",
    transform: "translate(-7.88 -9.94)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4643",
    "data-name": "Path 4643",
    d: "M11.97,15.051H8.55a.67.67,0,1,1,0-1.341H11.97a.67.67,0,0,1,0,1.341Z",
    transform: "translate(-7.88 -7.391)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4644",
    "data-name": "Path 4644",
    d: "M11.97,18.831H8.55a.67.67,0,1,1,0-1.341H11.97a.67.67,0,0,1,0,1.341Z",
    transform: "translate(-7.88 -4.835)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4645",
    "data-name": "Path 4645",
    d: "M11.97,22.611H8.55a.67.67,0,1,1,0-1.341H11.97a.67.67,0,1,1,0,1.341Z",
    transform: "translate(-7.88 -2.279)",
    fill: "#6f8b8f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4646",
    "data-name": "Path 4646",
    d: "M23.98,16.7a.672.672,0,0,1-.67-.67V15.68a.67.67,0,1,1,1.341,0v.352A.672.672,0,0,1,23.98,16.7Z",
    transform: "translate(3.156 -1.68)",
    fill: "#6f8b8f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactNormal);
export default __webpack_public_path__ + "static/media/Contact_Normal.9fe9da004be9a15ede08fd638766877a.svg";
export { ForwardRef as ReactComponent };